import {Component, inject, Input, OnChanges, OnDestroy, SimpleChanges} from '@angular/core';
import {TemplateSalvamentoModel} from '../../../../shared/model/template/template-salvamento-model';
import {TemplateMensagemService} from '../../../../shared/service/template-mensagem.service';
import {SafeResourceUrl} from '@angular/platform-browser';
import {
  DisparoAutomaticoVariavelModel
} from '../../../../shared/model/disparo-automatico/disparo-automatico-variavel.model';

@Component({
  selector: 'app-template-mensagem',
  standalone: true,
  imports: [],
  templateUrl: './template-mensagem.component.html',
  styleUrl: './template-mensagem.component.css'
})
export class TemplateMensagemComponent implements OnChanges, OnDestroy {
  @Input() template: TemplateSalvamentoModel = new TemplateSalvamentoModel();
  @Input() variaveis: DisparoAutomaticoVariavelModel[] = [];
  @Input() tipo = 'Whatsapp';

  textoTemplateOrigianal?: string;
  blob?: SafeResourceUrl;
  private chaveHeaderCarregado?: string;
  private urlBlob?: string;

  get corpoSms(): string {
    const body = this.template?.components?.find(comp => comp.type === 'BODY');
    return body?.text ?? '';
  }

  private readonly templateService = inject(TemplateMensagemService);

  ngOnChanges(changes: SimpleChanges) {
    if(changes['template']){
      const order = {
        HEADER: 1,
        BODY: 2,
        FOOTER: 3,
        BUTTONS: 4
      };
      this.template.components?.sort((a, b) => {
        // @ts-expect-error -- order não é indexável por qualquer string; a chave pode não existir no objeto
        return (order[a.type] || 99) - (order[b.type] || 99);
      });

      this.template.components?.forEach(comp => {
        if(comp.type === 'HEADER' && comp.format !== 'TEXT'){
          this.gerarImagem(comp.format);
        }
        if(comp.type === 'BODY' && comp.example && comp.example.length > 0){
          this.textoTemplateOrigianal = comp.text;
          this.variaveis.forEach(variavel => {
            this.trocarVariavelPorTexto(variavel);
          });
        }
      });
    }
    if(changes['variaveis']){
      this.template.components?.forEach(comp => {
        if(comp.type === 'BODY' && this.variaveis && this.variaveis.length > 0){
          this.variaveis.forEach(variavel => {
            this.trocarVariavelPorTexto(variavel);
          });
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.limparBlob();
  }

  trocarVariavelPorTexto(variavel: DisparoAutomaticoVariavelModel){
    if(variavel && variavel.valor){
      this.template.components.forEach(comp => {
        if (comp.type === 'BODY') {
          let textoRenderizado = this.textoTemplateOrigianal!;
          this.variaveis.forEach(variavel => {
            if(variavel.ordem && variavel.valor){
              const regex = new RegExp(`\\{\\{${variavel.ordem}\\}\\}`, 'g');
              textoRenderizado = textoRenderizado.replace(regex, variavel.valor);
            }
          });
          comp.text = textoRenderizado;
        }
      });
    }
  }

  gerarImagem(formato?: string){
    if (!this.template.id) {
      this.limparBlob();
      return;
    }
    const chaveHeader = `${this.template.id}:${formato ?? ''}`;
    if (this.chaveHeaderCarregado === chaveHeader) {
      return;
    }
    this.chaveHeaderCarregado = chaveHeader;
    this.templateService.buscarArquivoHeaderTemplate(this.template.id).subscribe({
      next: res => {
        this.limparBlob();
        if (res instanceof Blob && res.size > 0) {
          this.urlBlob = URL.createObjectURL(res);
          this.blob = this.urlBlob;
        }
      },
      error: () => this.limparBlob()
    });
  }

  private limparBlob(): void {
    if (this.urlBlob) {
      URL.revokeObjectURL(this.urlBlob);
      this.urlBlob = undefined;
    }
    this.blob = undefined;
  }
}
